import React from 'react';
import Select from 'react-select'

export const CurrencySelector = ({defaultCurrency = 'USD', onChange, currencyOptions = []}) => (
  <Select styles={{container: (provided) => ({...provided,
      width: '300px',
      margin: '2em 0 3em 0',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
  })}} options={currencyOptions} onChange={({value}) => onChange(value)} defaultValue={defaultCurrency}/>
);

export default CurrencySelector;
